// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_qE4if","item":"index_item_2EeWY"};